var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[(_vm.screenType === 'desktop')?_c('dictation-item-desktop',{attrs:{"item":_vm.item,"online-class":_vm.onlineClass,"dictation":_vm.dictation,"answers":_vm.answers}}):_c('dictation-item-mobile',{attrs:{"item":_vm.item,"online-class":_vm.onlineClass,"dictation":_vm.dictation,"answers":_vm.answers}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }